import { combineReducers } from '@reduxjs/toolkit';

import countries from './countries/slice';
import subdivisions from './subdivisions/slice';

export default combineReducers({
  subdivisions,
  countries,
});
